export const hourlyServerData = {
  header: {
    title: "خرید سرور ابری ساعتی",
    description: "سرور ابری ساعتی؛ انتخابی انعطاف‌پذیر",
    text: "با خرید سرور ابری ساعتی همه امکانات یک سرور مجازی قدرتمند را روی محیط ابری تجربه کنید. سرور ابری ساعتی مزایای زیرساخت ابری از جمله تغییر سریع میزان منابع حین استفاده از سرویس در کنار آپ‌تایم بالا را در اختیارتان می‌گذارد. با خرید سرور ابری ساعتی، هزینه سرویس، بر اساس تعداد ساعات استفاده محاسبه می‌شود و در زمان خاموش بودن سرور، تنها هزینه‌ای اندک را بابت نگهداری از فضای ذخیره‌سازی و آی‌پی پابلیک پرداخت می‌کنید. ",
    leftButtonText: "خرید سرور ابری ساعتی",
  },
  benefit: {
    title: "مزایای سرور ابری ساعتی آبالو",
    items: [],
  },
};

export const questions = [
  {
    title: "سرور ابری ساعتی چیست؟",
    answer:
      "سرور ابری ساعتی یک نوع سرور ابری است که می‌توانید برای مدت زمان کوتاه، به صورت ساعتی، از منابع آن استفاده کنید و تنها هزینه همان ساعات استفاده را بپردازید.",
  },
  {
    title: "چرا سرور ابری ساعتی را انتخاب کنم؟",
    answer:
      "اگر نیاز به سرور برای مدت کوتاهی دارید، مانند تست پروژه‌ها یا میزبانی موقت، سرور ابری ساعتی گزینه‌ای اقتصادی و انعطاف‌پذیر است.",
  },
  {
    title: "چگونه می‌توانم سرور ابری ساعتی سفارش دهم؟",
    answer:
      "می‌توانید با ثبت‌نام در پنل آبالون، پلن مورد نظر خود را انتخاب کرده و بلافاصله سرور را راه‌اندازی کنید.",
  },
  {
    title: "هزینه سرور ابری ساعتی چقدر است؟",
    answer:
      "هزینه‌ها بسته به منابع انتخابی (CPU، RAM، فضای ذخیره‌سازی و میزان ترافیک) متفاوت است و به صورت ساعتی محاسبه می‌شود.",
  },
  {
    title: "آیا می‌توانم منابع سرور ابری را در حین استفاده تغییر دهم؟",
    answer:
      "بله، می‌توانید منابع سرور خود را هر زمان که بخواهید افزایش یا کاهش دهید و هزینه متناسب با تغییرات محاسبه می‌شود.",
  },
  {
    title: "سرور ابری ساعتی برای چه پروژه‌هایی مناسب است؟",
    answer:
      "این نوع سرور برای تست نرم‌افزارها، اجرای پروژه‌های کوتاه‌مدت و یا راه‌اندازی سریع محیط‌های توسعه مناسب است.",
  },
  {
    title: "آیا می‌توانم سرور ابری ساعتی را در هر زمانی متوقف کنم؟",
    answer:
      "بله، می‌توانید سرور ابری را در هر زمان متوقف کنید. در حالت خاموش، هزینه CPU و RAM محاسبه نمی‌شود، اما هزینه Storage و آدرس IP عمومی کسر می‌شود.",
  },
  {
    title: "آیا اطلاعات من در سرور ابری ساعتی امن است؟",
    answer:
      "بله. آبالون با لایه‌های امنیتی متنوع سخت‌افزاری و نرم‌افزاری از سرویس‌های ابری محافظت می‌کند. علاوه بر این، در پنل سرور ابری ساعتی، به فایروال قابل تنظیم دسترسی دارید.",
  },
  {
    title: "چه سیستم‌عامل‌هایی روی سرور ابری ساعتی ارائه می‌شود؟",
    answer:
      "سرورهای آبالون از سیستم‌عامل‌های مختلفی مانند لینوکس (Rocky ،Fedora ،Ubuntu ،CentOS ،Debian و …) و ویندوز سرور پشتیبانی می‌کند.",
  },
  {
    title: "آیا پشتیبانی فنی برای سرور ابری ساعتی ارائه می‌شود؟",
    answer:
      "بله، تیم پشتیبانی به صورت ۲۴/۷ و به رایگان در دسترس است تا به شما در رفع مشکلات کمک کند.",
  },
];

export const featuresHourlyServer = [
  {
    title: "تحویل سرور در ۶۰ ثانیه",
    desc: "سرور ابری ساعتی با سیستم‌عامل انتخابی شما در کمتر از یک دقیقه آماده شده و به‌صورت کاملاً خودکار تحویل داده می‌شود.",
    logo: "1minute.svg",
    alt: "پیاده‌سازی IAM امنیت ابری آبالون",
  },
  {
    title: "انتخاب آسان سیستم‌عامل",
    desc: "هنگام خرید سرور ابری ساعتی، سیستم‌عامل دلخواه ویندوز یا لینوکس را انتخاب کرده و به سرعت تنظیمات دلخواه را اعمال کنید.",
    logo: "chooseOs.svg",
    alt: "پیاده‌سازی سندباکس امنیت ابری آبالون",
  },
  {
    title: "کنترل پیشرفته با کنسول تحت وب",
    desc: "با استفاده از کنسول تحت وب، حتی در صورت قطع دسترسی به اینترنت، به مدیریت و کنترل کامل سرور ابری ساعتی خود ادامه دهید.",
    logo: "console.svg",
    alt: "پیاده‌سازی SIEM امنیت ابری آبالون",
  },
  {
    title: "دسترسی جهانی به سرور",
    desc: "از هر نقطه جهان و در هر زمانی، به سرورهای ابری ساعتی متصل شوید و بدون محدودیت مکانی، سرویس‌های خود را مدیریت کنید.",
    logo: "global.svg",
    alt: "پیاده‌سازی DMZ امنیت ابری آبالون",
  },
  {
    title: "انعطاف در افزایش منابع",
    desc: "در هر لحظه از شبانه‌روز، منابع سرور ابری ساعتی خود را افزایش یا کاهش دهید تا پاسخی برای نیازهای لحظه‌ای کسب‌وکار خود داشته باشید.",
    logo: "increase.svg",
    alt: "ابزار مقابله با ویروس‌ها امنیت ابری آبالون",
  },
  {
    title: "پشتیبانی ۲۴/۷ رایگان",
    desc: "با سرور ابری ساعتی، از پشتیبانی حرفه‌ای و رایگان به‌صورت ۲۴/۷/۳۶۵ بهره‌مند شوید تا در هر شرایطی تنها یک تماس از حل مشکل‌تان فاصله داشته باشید.",
    logo: "24.svg",
    alt: "اسکن آسیب‌پذیری‌های امنیتی",
  },
  {
    title: "امنیت پیشرفته با فایروال",
    desc: "قوانین امنیتی سرور ابری ساعتی را مطابق نیازهای خود تنظیم کنید و با فایروال پیشرفته از سرورهای خود در برابر تهدیدات محافظت کنید.",
    logo: "firewall-new.svg",
    alt: "بازیابی ناشی از سانحه امنیت ابری آبالون",
  },
  {
    title: "آپ‌تایم ۹۹.۹۹ درصد",
    desc: "سرورهای ابری ساعتی با بالاترین سطح آپ‌تایم، تضمین می‌کنند که سرویس‌های شما همواره در دسترس باشند.",
    logo: "uptime.svg",
    alt: "پیاده‌سازی ابزارهای DLP امنیت ابری آبالون",
  },
];

export const benefitHourlyServer = [
  {
    name: "امنیت داده‌ها در اولویت",
    logo: "infrustructure.svg",
    alt: "انتخاب سطح سرویس حین خرید سرور ابری",
    title: "انتخاب سطح سرویس حین خرید سرور ابری",
  },
  {
    name: "پشتیبانی ۲۴/۷/۳۶۵",
    logo: "support.svg",
    alt: "پشتیبانی ۲۴ ساعته سرور ابری",
    title: "پشتیبانی ۲۴ ساعته سرور ابری",
  },
  {
    name: "سرویس منعطف برای نیازهای متنوع",
    logo: "sla.svg",
    alt: "زیرساخت ایمن سرور ابری",
    title: "زیرساخت ایمن سرور ابری",
  },
  {
    name: "پشتیبانی فنی رایگان",
    logo: "freeSupport.svg",
    alt: "پنل یکپارچه مدیریت سرور ابری",
    title: "پنل یکپارچه سرور ابری",
  },
  {
    name: "منابع پیشرفته برای بهترین عملکرد",
    logo: "hq.svg",
    alt: "کیفیت بالای منابع سرور ابری",
    title: "کیفیت بالای منابع سرور ابری",
  },
  {
    name: "یکپارچگی کامل در خدمات ابری",
    logo: "dashboard.svg",
    alt: "پشتیبانی رایگان سرور ابری آبالون",
    title: "پشتیبانی رایگان سرور ابری آبالون",
  },
];

export const tabItems = [
  {
    title: "مدیریت سرور کاربردی",
    img: "ddos.svg",
    img_deactive: "ddos-d.svg",
    section_title: "پنل مدیریت سرور کاربردی",
    caption:
      "در پنل مدیریت سرور ابری ساعتی ایران، تمام سرورها به‌صورت تفکیک‌شده نمایش داده می‌شوند و اطلاعاتی مانند مدت‌زمان باقی‌مانده سرویس، آدرس آی‌پی و مشخصات سیستم‌عامل به‌راحتی قابل مشاهده است. همچنین، امکان دسترسی سریع به کنسول سرور برای عملیاتی نظیر روشن، خاموش، ری‌استارت و بازسازی سرور با سیستم‌عامل دیگر فراهم شده است.",
    contentImg: "list-vps.f735948 1.svg",
    logo_alt: "مدیریت سرور ابری",
    logo_title: "مدیریت سرور ابری",
    img_alt: "پنل مدیریت سرور ابری",
    img_title: "پنل مدیریت سرور ابری",
  },
  {
    title: "تنظیمات فایروال",
    img: "waf-icon-active.svg",
    img_deactive: "waf-icon.svg",
    section_title: "تنظیمات فایروال",
    caption:
      "سرور ابری ساعتی ایران امکان تنظیم رول‌های متنوع فایروال را فراهم می‌کند. می‌توانید قوانین دلخواه ورودی و خروجی را بر اساس پروتکل، آدرس آی‌پی مبدا یا مقصد و پورت‌های مختلف تعریف کنید. همچنین، بدون هیچ محدودیتی در تعداد رول‌ها، امکان افزودن یا حذف قوانین در اختیار شما قرار دارد.",
    contentImg: "waf-vps.fcecd73 1.svg",
    alt: "تعیین محدودیت درخواست",
    logo_alt: "فایروال سرور ابری",
    logo_title: "فایروال سرور ابری",
    img_alt: "تنظیمات فایروال سرور ابری",
    img_title: "فایروال سرور ابری",
  },
  {
    title: "نمایش مصرف ترافیک سرور",
    img: "waf.svg",
    section_title: "نمودار مصرف ترافیک سرور",
    img_deactive: "waf-d.svg",
    caption:
      "سرور ابری ساعتی ایران به شما امکان مشاهده ترافیک مصرفی هر سرور را در قالب نمودارهای دقیق می‌دهد. با تنظیم بازه‌های زمانی دلخواه می‌توانید مصرف ترافیک روزانه یا ساعتی را بررسی کنید. همچنین، گزارش‌های جامع از میزان ترافیک مصرف‌شده برای تحلیل بهتر در دسترس شما است.",
    contentImg: "traffic-vps.aa00c67 1.svg",
    alt: "فایروال وب (WAF)",
    logo_alt: "نمودار مصرف ترافیک سرور ابری",
    logo_title: "نمودار مصرف ترافیک سرور ابری",
    img_alt: "نمودار مصرف سرور ابری",
    img_title: "نمودار مصرف سرور ابری",
  },
];

export const hourlyServerUsage = [
  {
    title: "ترید سریع",
    desc: "سرور ابری ساعتی با ارائه آی‌پی عمومی و شبکه‌ای پرسرعت، گزینه‌ای ایده‌آل برای ترید است. این سرویس امکان خاموش کردن سرور در زمان عدم نیاز را فراهم می‌کند.",
    logo: "startup.svg",
    imgAlt: "DNS رایگان",
    imgTitle: "DNS رایگان",
  },
  {
    title: "محیط توسعه",
    desc: "محیط‌های تست و توسعه را به‌سادگی و با پرداخت هزینه ساعتی راه‌اندازی کنید و نرم‌افزارهای خود را آزمایش کنید.",
    logo: "test.svg",
    imgAlt: "سرورهای جهانی DNS ابری آبالون",
    imgTitle: "سرورهای جهانی DNS ابری آبالون",
  },
  {
    title: "بکاپ‌گیری",
    desc: "با سرور ابری ساعتی، نسخه‌های پشتیبان از داده‌های حساس خود تهیه کنید و با کمترین هزینه، از امنیت اطلاعات سازمان اطمینان داشته باشید..",
    logo: "disaster.svg",
    imgAlt: "DNS ابری با پشتیبانی از رکوردهای رایج",
    imgTitle: "DNS ابری با پشتیبانی از رکوردهای رایج",
  },
  {
    title: "پروژه‌های کوتاه‌مدت",
    desc: "برای پروژه‌های موقت و کوتاه‌مدت، سرور را با منابع مورد نیاز خود و مدت زمان دلخواه راه‌اندازی کرده و استفاده کنید..",
    logo: "virtualOrganization.svg",
    imgAlt: "آپ‌تایم صددرصد DNS ابری",
    imgTitle: "آپ‌تایم صددرصد DNS ابری",
  },
];

export const abalonPopularServices = [
  {
    title: "دیتاسنتر ابری",
    desc: "دیتاسنتر ابری تمامی قابلیت‌های یک دیتاسنتر فیزیکی را روی ابر برایتان فراهم می‌کند و می‌تواند پاسخی برای پیچیده‌ترین و تخصصی‌ترین نیازهای ابری شما باشد. ",
    logo: "VPC-Service.svg",
    route: "/vpc",
    imgAlt: "دیتاسنتر ابری آبالون",
    imgTitle: "دیتاسنتر ابری آبالون",
  },
  {
    title: "شبکه توزیع محتوا (CDN)",
    desc: "با استفاده از CDN، امنیت و سرعت بارگذاری وب‌سایت خود را بهبود دهید. داده‌های شما از طریق سرورهای توزیع‌شده همیشه نزدیک‌تر به کاربران خواهند بود.",
    logo: "CloudGuard-Service.svg",
    route: "/cdn",
    imgAlt: "شبکه توزیع محتوا (CDN) آبالون",
    imgTitle: "شبکه توزیع محتوا (CDN) آبالون",
  },
  {
    title: "DNS ابری",
    desc: "با استفاده از DNS ابری، بدون نیاز به مدیریت سرورهای DNS، رکوردها و Zoneهای DNS، همه دامنه‌های خود را مدیریت و در تمام جهان منتشر کرده و سرعت پاسخ‌گویی به کاربران را افزایش دهید.",
    logo: "DNS.svg",
    route: "/dns",
    imgAlt: "DNS ابری آبالون",
    imgTitle: "DNS ابری آبالون",
  },
  {
    title: "سرویس مدیریت شده",
    desc: "تحت سرویس‌های مدیریت شده، راهکارهای اختصاصی سازمان شما در حوزه ابری، از جمله نصب سیستم‌عامل و نرم‌افزار، طراحی معماری و مهاجرت ابری اجرا می‌شود.",
    logo: "ManagedService-Service.svg",
    route: "/manageservices",
    imgAlt: "سرویس مدیریت شده",
    imgTitle: "سرویس مدیریت شده",
  },
];
